import { FoundationFinance } from '@models';
import { MutationPayload } from './mutation-payload';

export interface UpdateFoundationFinanceResult {
  updateFoundationFinance: UpdateFoundationFinancePayload;
}

export interface UpdateFoundationFinancePayload extends MutationPayload {
  foundationFinance: FoundationFinance;
}
